module.exports = __webpack_public_path__ + "img/44.7d40c876.png";